// REACT
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR
import styled from 'styled-components';
import CircularProgress from 'material-ui/CircularProgress';

// CUSTOM COMPONENTS
import CompanyPortalWizardDialog from 'containers/CompanyContainer/CompanyPortalWizardDialog';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import FormPhoneNumberField from 'containers/CompanyContainer/Forms/Components/FormPhoneNumberField';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import ActivationCodeDisplay from 'containers/CompanyContainer/ActivationCodeDisplay';
import PText from 'components/Primatives/PText';

// UTILS
import { numbersOnly } from 'utils/stringUtils';
import validate from 'containers/CompanyContainer/Forms/Validation';

class GetAddClientWizardStep extends React.Component {
    state = {
        email: '',
        confirmEmail: '',
        areEmailsValid: false,
        emailError: null,
        errorColor: null,
        firstNameError: null,
        lastNameError: null,
        phoneNumberError: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        loading: false,
    };

    handleWizardStepChange = offset => {
        const { currentWizardStep } = this.props;
        const newPage = currentWizardStep + offset;
        this.props.changeWizardStep({ newPage });
        window.scrollTo(0, 0);
    };

    confirmClientAddition = () => {
        let {
            getCurrentBookingClientData,
            handleDialogStatusChange,
            tempBookingData,
        } = this.props;
        if (tempBookingData) {
            handleDialogStatusChange({
                open: true,
                type: 'bookWithClient',
                step: 6,
            });
        } else if (!tempBookingData) {
            handleDialogStatusChange({ open: false, type: null, step: null });
            this.setState({ email: '', emailError: null });
        }
    };

    checkIfEmailsMatch = () => {
        let { email, confirmEmail } = this.state;
        if (email !== confirmEmail || email.length === 0) {
            this.setState({
                emailError: 'Email addresses do not match',
                areEmailsValid: false,
                errorColor: null,
            });
        } else if (email === confirmEmail) {
            let isValidEmailMessage = validate('email', email);
            if (isValidEmailMessage) {
                this.setState({
                    emailError: isValidEmailMessage,
                    areEmailsValid: false,
                    errorColor: null,
                });
            } else if (!isValidEmailMessage) {
                this.setState({
                    emailError: 'Email addresses match',
                    areEmailsValid: true,
                    errorColor: '#27AE61',
                });
            }
        }
    };

    resetEmailForm = () => {
        this.handleWizardStepChange(-1);
        this.setState({
            email: '',
            confirmEmail: '',
            emailError: null,
            areEmailsValid: false,
            errorColor: null,
        });
    };

    validateEmails = () => {
        const { email, confirmEmail } = this.state;

        this.setState(
            {
                loading: true,
            },
            () => {
                this.props
                    .validateEmailWithMailgun(email)
                    .then(validationResponse => {
                        if (validationResponse === true) {
                            this.props
                                .findClientAccount({ email })
                                .then(nextWizardStep => {
                                    if (nextWizardStep === 0) {
                                        this.setState({
                                            emailError:
                                                'That email is already in use',
                                            areEmailsValid: true,
                                            loading: false,
                                            errorColor: null,
                                        });
                                    } else if (nextWizardStep === 1) {
                                        this.handleWizardStepChange(
                                            nextWizardStep,
                                        );
                                        this.setState({
                                            emailError: null,
                                            areEmailsValid: true,
                                            loading: false,
                                        });
                                    }
                                })
                                .catch(err => console.log(err));
                        } else if (!validationResponse) {
                            this.setState({
                                emailError: 'Invalid email address',
                                areEmailsValid: false,
                                loading: false,
                                errorColor: null,
                            });
                        } else {
                            this.setState({
                                emailError: validationResponse,
                                areEmailsValid: true,
                                loading: false,
                            });
                        }
                    })
                    .catch(err => console.log(err));
            },
        );
    };

    validatePhoneNumberLength = phoneNumber => {
        const unMaskedPhoneNumber = numbersOnly(phoneNumber);
        if (unMaskedPhoneNumber.length === 11) {
            return true;
        } else {
            return false;
        }
    };

    validatePhoneNumber = phoneNumber => {
        const unMaskedPhoneNumber = numbersOnly(phoneNumber);
        if (unMaskedPhoneNumber === ('15555555555' || 15555555555)) {
            return false;
        } else {
            return true;
        }
    };

    validateDetails = () => {
        let { firstName, lastName, phoneNumber } = this.state;
        const unMaskedPhoneNumber = numbersOnly(phoneNumber);
        if (!firstName) {
            this.setState({ firstNameError: 'required' });
        }
        if (!lastName) {
            this.setState({ lastNameError: 'required' });
        }
        if (!phoneNumber) {
            this.setState({ phoneNumberError: 'required' });
        }
        if (!this.validatePhoneNumberLength(phoneNumber)) {
            this.setState({ phoneNumberError: 'must be a full phone number' });
        }

        if (!this.validatePhoneNumber(phoneNumber)) {
            this.setState({ phoneNumberError: 'must be a valid phone number' });
        } else if (
            firstName &&
            lastName &&
            phoneNumber &&
            this.validatePhoneNumberLength(phoneNumber) &&
            this.validatePhoneNumber(phoneNumber)
        ) {
            this.createClientAccount();
            this.setState({
                firstNameError: null,
                lastNameError: null,
                phoneNumberError: null,
                loading: true,
            });
        }
    };

    createClientAccount = () => {
        const { providerCompany } = this.props.userData;
        let { firstName, lastName, phoneNumber, email } = this.state;
        let { createUserAccount, getCurrentBookingClientData } = this.props;
        const unMaskedPhoneNumber = numbersOnly(phoneNumber);
        if (unMaskedPhoneNumber.length === 11) {
            createUserAccount({
                companyId: providerCompany,
                email,
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                phoneNumber: unMaskedPhoneNumber,
            })
                .then(tempNewClientDataKey => {
                    console.log('191', tempNewClientDataKey);
                    if (tempNewClientDataKey) {
                        getCurrentBookingClientData({
                            tempNewClientDataKey,
                            companyId: providerCompany,
                        })
                            .then(confirmed => {
                                this.setState({ loading: false }, () => {
                                    this.handleWizardStepChange(1);
                                });
                            })
                            .catch(err => console.log(err));
                    }
                })
                .catch(err => console.log(err));
        }
    };

    GetAddClientWizardStepContent = pageNumber => {
        let titleProps;
        let body;
        let actions;
        let key = pageNumber;
        const {
            email,
            confirmEmail,
            state,
            firstName,
            lastName,
            phoneNumber,
            firstNameError,
            lastNameError,
            phoneNumberError,
            emailError,
            areEmailsValid,
            errorColor,
            loading,
        } = this.state;

        switch (pageNumber) {
            case 0:
                titleProps = {
                    title: `Enter your client's email to add them to your client list`,
                    subtitle: loading ? 'Please wait...' : '',
                    subtitleColor: 'blue',
                    hasBorder: false,
                };
                body = loading ? (
                    <CircularProgress size={50} />
                ) : (
                    [
                        <React.Fragment>
                            <FormTextField
                                label={"Enter client's email address"}
                                name={email}
                                value={email}
                                onChange={e => {
                                    this.setState(
                                        { email: e.target.value.trim() },
                                        () => this.checkIfEmailsMatch(),
                                    );
                                }}
                                errorMessage={emailError}
                                messageColor={errorColor}
                            />
                            <FormTextField
                                label={'Confirm email'}
                                name={confirmEmail}
                                value={confirmEmail}
                                onChange={e => {
                                    this.setState(
                                        { confirmEmail: e.target.value.trim() },
                                        () => this.checkIfEmailsMatch(),
                                    );
                                }}
                                errorMessage={emailError}
                                messageColor={errorColor}
                            />
                        </React.Fragment>,
                    ]
                );
                actions = loading
                    ? [null]
                    : [
                          <CompanyPageButton
                              key={key}
                              type={'dark'}
                              children={'Add client'}
                              disabled={!areEmailsValid}
                              // SETTING EMAIL TO INVALID TO UNTIL A RESPONSE IS RECEIVED FROM MAILGUN VALIDATOR
                              onClick={() => {
                                  this.setState({ areEmailsValid: false }, () =>
                                      this.validateEmails(),
                                  );
                              }}
                          />,
                      ];
                break;
            case 1:
                titleProps = {
                    title: email,
                    subtitle: 'Does not have an account yet',
                    subtitleColor: 'red',
                    hasBorder: true,
                };
                body = null;
                actions = [
                    <CompanyPageButton
                        key={key}
                        type={'light'}
                        children={'Try a different email'}
                        onClick={() => this.resetEmailForm()}
                        size="small"
                    />,
                    <CompanyPageButton
                        key={key + 1}
                        type={'dark'}
                        children={'Create account'}
                        onClick={() => this.handleWizardStepChange(1)}
                        size="small"
                    />,
                ];
                break;
            case 2:
                titleProps = {
                    title: email,
                    subtitle: loading
                        ? `Give us a moment.  We're setting up your new client.`
                        : null,
                    subtitleColor: 'blue',
                    hasBorder: false,
                };
                body = loading ? (
                    <CircularProgress size={50} />
                ) : (
                    <React.Fragment>
                        <FormTextField
                            label={'First name'}
                            name={firstName}
                            value={firstName}
                            onChange={e =>
                                this.setState({
                                    firstName: e.target.value.trimStart(),
                                })
                            }
                            required="required"
                            errorMessage={firstNameError}
                        />
                        <FormTextField
                            label={'Last name'}
                            name={lastName}
                            value={lastName}
                            onChange={e =>
                                this.setState({
                                    lastName: e.target.value.trimStart(),
                                })
                            }
                            required="required"
                            errorMessage={lastNameError}
                        />
                        <FormPhoneNumberField
                            label={'Phone number'}
                            name={phoneNumber}
                            value={phoneNumber}
                            onChange={e =>
                                this.setState({
                                    phoneNumber: e.target.value.trim(),
                                })
                            }
                            required="required"
                            errorMessage={phoneNumberError}
                        />
                    </React.Fragment>
                );
                actions = loading
                    ? [null]
                    : [
                          <CompanyPageButton
                              key={key}
                              children={'Back'}
                              buttonStyle={{
                                  color: 'white',
                                  background: 'grey',
                              }}
                              onClick={() => {
                                  this.handleWizardStepChange(-1);
                              }}
                          />,
                          <CompanyPageButton
                              key={key + 1}
                              children={'Next'}
                              type={'dark'}
                              onClick={this.validateDetails}
                          />,
                      ];
                break;
            case 3:
                titleProps = {
                    title: email,
                    subtitle: 'Account created',
                    subtitleColor: 'blue',
                    hasBorder: true,
                };
                body = (
                    <div>
                        <ActivationCodeDisplay
                            code={this.props.tempActivationCode}
                        />
                        <PText>
                            You must give this code to the client so they can
                            activate the account. You can access this code later
                            in your company client list
                        </PText>
                    </div>
                );

                actions = [
                    <CompanyPageButton
                        key={key}
                        type={'dark'}
                        children={'Next'}
                        onClick={() => this.handleWizardStepChange(1)}
                    />,
                ];
                break;
            case 4:
                titleProps = {
                    title: email,
                    subtitle: loading ? 'Please wait...' : 'Direct billing',
                    subtitleColor: 'blue',
                    hasBorder: true,
                };
                body = loading ? (
                    <CircularProgress size={50} />
                ) : (
                    <PText>
                        It is your company's responsibility to charge direct
                        billing after completion of the service. Please confirm
                        that you have the customer's credit card and insurance
                        information on file
                    </PText>
                );

                actions = [
                    <CompanyPageButton
                        key={key}
                        type={'dark'}
                        children={'Confirm'}
                        disabled={loading}
                        onClick={() =>
                            this.setState({ loading: true }, () =>
                                this.confirmClientAddition(),
                            )
                        }
                    />,
                ];
                break;
        }
        return (
            <CompanyPortalWizardDialog
                headerProps={titleProps}
                body={body}
                actions={actions}
            />
        );
    };

    render() {
        let { pageNumber } = this.props;
        let child = this.GetAddClientWizardStepContent(pageNumber);
        return <React.Fragment>{child}</React.Fragment>;
    }
}

const mapStateToProps = ({ company, client, booking }) => ({
    userData: client.clientData,
    currentWizardStep: company.currentWizardStep,
    tempActivationCode: company.tempActivationCode,
    tempBookingData: booking.tempBookingData,
});

export default connect(
    mapStateToProps,
    actions,
)(GetAddClientWizardStep);



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/GetAddClientWizardStep.jsx